var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFlagSpanish = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
  fill: "#C4C4C4"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-2 6.4H31.6V0H-2V6.4Z",
  fill: "#DD172C"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-2 24H31.6V17.6H-2V24Z",
  fill: "#DD172C"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-2 17.6H31.6V6.39996H-2V17.6Z",
  fill: "#FFD133"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.79998 11.2H8.39998V12H6.79998V11.2Z",
  fill: "#FFEDB1"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.93059 11.2L5.66946 11.2L5.875 13.6665C5.90955 14.0811 6.25617 14.4 6.67224 14.4H6.92781C7.34388 14.4 7.6905 14.0811 7.72505 13.6665L7.93059 11.2ZM5.66946 10.4C5.20143 10.4 4.83336 10.8 4.87223 11.2665L5.07776 13.7329C5.14687 14.5622 5.8401 15.2 6.67224 15.2H6.92781C7.75995 15.2 8.45318 14.5622 8.52229 13.7329L8.72782 11.2665C8.76669 10.8 8.39862 10.4 7.93059 10.4H5.66946Z",
  fill: "#A41517"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.2 12H8.4V12.8H7.6L6.8 14.4L6 12.8H5.2V12Z",
  fill: "#A41517"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.8 10.4C2.8 9.95818 3.15817 9.60001 3.6 9.60001C4.04183 9.60001 4.4 9.95818 4.4 10.4V14.4C4.4 14.8418 4.04183 15.2 3.6 15.2C3.15817 15.2 2.8 14.8418 2.8 14.4V10.4Z",
  fill: "#A41517"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.19998 10.4C9.19998 9.95818 9.55815 9.60001 9.99998 9.60001C10.4418 9.60001 10.8 9.95818 10.8 10.4V14.4C10.8 14.8418 10.4418 15.2 9.99998 15.2C9.55815 15.2 9.19998 14.8418 9.19998 14.4V10.4Z",
  fill: "#A41517"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.2 9.28003C5.2 8.57311 5.77308 8.00003 6.48 8.00003H7.12C7.82692 8.00003 8.4 8.57311 8.4 9.28003C8.4 9.45676 8.25673 9.60003 8.08 9.60003H5.52C5.34327 9.60003 5.2 9.45676 5.2 9.28003Z",
  fill: "#A41517"
}))));
export default SvgFlagSpanish;